// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { DocumentRemindersInstance } from "./helpers/documentRemindersInstanceHelpers";
import { createDocumentRemindersInstance } from "./helpers/documentRemindersInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseNotary, DocumentRemindersInstance>({
	name: "DocumentReminders",
	createBase: createBaseNotary,
	createInstance: createDocumentRemindersInstance,
});

export function getDocumentRemindersInstance(): DocumentRemindersInstance {
	return factory.getInstance();
}
